import { Component, Input, Inject } from "@angular/core";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Dictionary } from "../store/models/common_types";
import { ResearchGridDataService } from "../research-grid-page/research-grid-data.service";
import { DOCUMENT } from "@angular/common";
import { AppService } from "../app.service";
import { VAIconRegistryService, download } from "@va/core-library/icons";

@Component({
  selector: "app-download-renderer",
  template: `
    <p
      *ngIf="dataValue.show"
      class="clickable"
      (click)="onClickDownload($event)"
    >
      <ng-template #indicatorTemplate
        ><va-icon
          size="small"
          [name]="faSpinner"
          isFontAwesome="true"
          [spin]="true"
        ></va-icon
      ></ng-template>
      <nz-spin *ngIf="loading" nzSimple [nzIndicator]="indicatorTemplate">
      </nz-spin>
      <va-icon *ngIf="!loading" size="small" name="download"></va-icon>
    </p>
  `,
  styles: [".clickable {cursor: pointer; margin:0}"],
})
export class DownloadRendererComponent {
  @Input() dataValue: Dictionary<any>;
  @Input() docId: number;
  faSpinner = faSpinner;
  loading = false;

  constructor(
    private dataService: ResearchGridDataService,
    private appService: AppService,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([download]);
  }

  getDownloadDocumentName = (nameParams: any) => {
    let docName = "";
    const titleForDocName = nameParams.displayText.substring(0, 15);
    const dateForDocName = nameParams.publicationDate.split("T")[0];
    const pageCountForDocName =
      nameParams.pageCount !== null ? `-${nameParams.pageCount} pages` : "";
    docName = `${dateForDocName}-${nameParams.brokerShortName}-${nameParams.ticker}-${titleForDocName}${pageCountForDocName}`;
    return docName;
  };

  onClickDownload(event: any) {
    this.loading = true;
    const dataToPass = this.dataValue.data;
    const fileName = this.getDownloadDocumentName(dataToPass);
    const downloadUrl = this.dataService.getDownloadDocumentURL(
      dataToPass.id,
      dataToPass.companyId,
      fileName,
      dataToPass.enableWatermark,
    );
    const startIFrameTime = new Date().getTime();
    // this.dataService
    //   .getDownloadDocumentURL(dataToPass.id, dataToPass.companyId, fileName)
    //   .subscribe(
    //     () => {
    //       setTimeout(() => {
    //       this.loading = false;
    //       }, 2000);
    //     },
    //     () => {
    //       setTimeout(() => {
    //       this.loading = false;
    //       }, 2000);
    //     }
    //   );
    const iFrameToLoad = this._document.createElement("iframe");
    const body = this._document.getElementsByTagName("body")[0];
    iFrameToLoad.id = `research_download_${dataToPass.id}`;
    iFrameToLoad.name = `research_download_${dataToPass.id}`;
    iFrameToLoad.src = downloadUrl;
    iFrameToLoad.setAttribute("style", "visibility:hidden;display:none");
    body.appendChild(iFrameToLoad);

    const checkInterval = setInterval(() => {
      const iFrameToGet = this._document.getElementById(
        `research_download_${dataToPass.id}`,
      ) as HTMLIFrameElement;
      const iFrame =
        iFrameToGet.contentDocument || iFrameToGet.contentWindow.document;
      /*
        This check will run till the iFrame either doesn't load or for a max of 30secs
        Or till the ready state of the iFrame doesn't evaluate
      */
      if (
        iFrame.readyState === "complete" ||
        iFrame.readyState === "interactive" ||
        new Date().getTime() - startIFrameTime > 30000
      ) {
        //Commenting for now
        // this._document
        //   .getElementById(`research_download_${dataToPass.id}`)
        //   .remove();
        this.loading = false;
        clearInterval(checkInterval);
        return;
      }
    }, 2000);
    // iframe.onload = () => {
    //   setTimeout(function() {
    //     document.getElementById(`research_download_${dataToPass.id}`).remove();
    //   }, 100);
    //   this.loading = false;
    // };
    const extras = {
      beginning_state_referrer: "Dedicated_Research_Page",
      research_id: dataToPass.id,
      research_type: dataToPass.type,
    };
    this.appService.logUserAction(
      event,
      dataToPass.ticker,
      "",
      "Research_Downloaded_From_DedicatedPage",
      extras,
      "",
      "",
    );
  }
}
